/**
 * La voix de Hoa, ou celle d'un organisateur.
 *
 * Dans un événement, ce n'est plus Hoa qui parle : c'est la personne qui
 * l'organise, avec son nom et son image (profil annonceur de la régie).
 * Hors événement, Hoa reprend la parole.
 *
 * Un petit magasin hors de React, comme les annonces : le moaï est dessiné
 * par une vingtaine d'écrans qui n'ont pas à savoir d'où vient la voix.
 * L'événement en cours est écrit sur l'appareil, pour survivre à un
 * rechargement.
 */
import { useEffect, useState } from "react";

export interface VoixEvenement {
  nom: string;
  image: string | null;
  phrase: string;
  /** La couleur de la marque (Espaces Humains). */
  couleur?: string | null;
}

export interface EvenementCourant {
  id: string;
  nom: string;
  voix: VoixEvenement | null;
}

const CLE = "hoa.evenement";
let courant: EvenementCourant | null = lire();
const abonnes = new Set<() => void>();

function lire(): EvenementCourant | null {
  try {
    const v = localStorage.getItem(CLE);
    return v ? (JSON.parse(v) as EvenementCourant) : null;
  } catch {
    return null;
  }
}

export function poserEvenement(e: EvenementCourant | null): void {
  courant = e;
  try {
    if (e) localStorage.setItem(CLE, JSON.stringify(e));
    else localStorage.removeItem(CLE);
  } catch {
    /* navigation privée : la mémoire vive suffit pour la visite */
  }
  for (const f of abonnes) f();
}

export function evenementCourant(): EvenementCourant | null {
  return courant;
}

export function useVoix(): VoixEvenement | null {
  const [v, setV] = useState<VoixEvenement | null>(courant?.voix ?? null);
  useEffect(() => {
    const f = (): void => setV(courant?.voix ?? null);
    abonnes.add(f);
    f();
    return () => {
      abonnes.delete(f);
    };
  }, []);
  return v;
}
